import * as React from 'react';
import { isNullOrUndefined } from 'util';
import { Utils, DateFormatter, domain, domainVal, UiUtils, i18n, isAuth, NumberFormatter, } from 'arm-common';

class FormatMoney {
    constructor() {
        this.componentName = "[FormatMoney.js] ";
    }

    //amount, decimalCount = 2, decimal = ".", thousands = ","
    formatMoney(amount, decimalCount, decimal, thousands, currency ) {
        try {
          decimalCount = Math.abs(decimalCount);
          decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
          currency= isNullOrUndefined(currency) ? "€" : currency;
          const negativeSign = amount < 0 ? "-" : "";
      
          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;
      
          return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "") + " " + currency;
        } catch (e) {
            console.warn("FormatMoney" + e);
        }
      };
}


export default FormatMoney = new FormatMoney;